/**
 * Reads a text field from a FormData set. A FormData entry can also be a File, so the value is narrowed
 * rather than stringified — stringifying a File would silently produce a useless value.
 */
export function readTextField(formData: FormData, name: string): string {
  const value = formData.get(name);
  return typeof value === 'string' ? value : '';
}
